export enum ExportMode {
    Fax = 1,
    Print = 2,
    Sign = 3,
    UseSigned = 4,
    SendToPortal = 5
}
